module.exports = __webpack_public_path__ + "static/img/xlh-qrcode.236a4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contactUs/xlh-qrcode.png
// module id = FtsW
// module chunks = 0